<div>
    <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.booking_details' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">

    <app-workshop-jobcard-booking-details [jobcard]="jobcard"
        [serviceTypes]="(ctx.serviceTypes$ | async)" [technicians]="(ctx.technicians$ | async)"
        [systemUsers]="(ctx.systemUsers$ | async)" [thirdParties]="(ctx.thirdParties$ | async)" (jobcardChange)="updateJobcard($event)">
    </app-workshop-jobcard-booking-details>

</div>
<div class="modal-footer-container">
    <div class="button-container">
        <hub-button [text]="'general.close' | translate" [style]="'secondary'" (buttonClick)="close()"
            [size]="'xl'"></hub-button>
    </div>
</div>